import apiClient from "api/client/axios.client";
import axios from "axios";

export interface MediaItemDto {
  id: string;
  name?: string;
  medium?: string; // base64
  thumbnail?: string; // base64
  extension?: string;
  mimeType?: string;
  size?: number;
  isDefault: boolean;
}

export interface UploadMediaResultDto {
  albumId: string;
  createdMediaIds: string[];
}

export const uploadMedia = async (albumId: string | undefined | null, file: File) => {
  const formData = new FormData();
  
  // اگر albumId وجود داشت ارسال شود
  if (albumId) {
    formData.append('albumId', albumId);
  }
  
  // نام کلید باید دقیقا با نام پارامتر در بک‌اند (List<IFormFile> files) یکسان باشد
  formData.append('files', file); 

  const response = await apiClient.post('/Medium/v1/Media/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};


export const getMediaByAlbumId = async (albumId: string): Promise<MediaItemDto[]> => {
  const response = await apiClient.get<MediaItemDto[]>(
    `/Medium/v1/Media/album/${albumId}`
  );
  return response.data;
};

export const deleteMedia = async (mediaId: string): Promise<void> => {
  await apiClient.post("/Medium/v1/Media/delete", { mediaId });
};

export const setDefaultMedia = async (albumId: string, mediaId: string): Promise<void> => {
  await apiClient.post("/Medium/v1/Media/set-default", { albumId, mediaId });
};
